import * as type from './types';
import axios from '../../../common/config/axios';

export const getLink = () => dispatch => {
    axios.get('promote/link')
    .then((response) => {
        dispatch({
            type: type.GET_LINK,
            payload: response.data
        });
    }).catch(err => {
        // console.warn(err);
    })
};